<app-settings-base
  title="{{'rdwCarDataSettings.title' | translate}}"
  description="{{'rdwCarDataSettings.text' | translate}}"
  details="{{'rdwCarDataSettings.detailsHeader' | translate}}"
  sourceUrl="/setting/rdw-cardata">
</app-settings-base>
